import React from 'react';
import { useSelector } from 'react-redux';
import { FaTruckMoving, FaBoxOpen, FaUser } from 'react-icons/fa';
import { MdPerson } from 'react-icons/md';
import { Icon } from '@iconify/react';
import circleTick from '@iconify/icons-charm/circle-tick';
import 'bootstrap/dist/css/bootstrap.min.css';

const RentalTerms = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      title: 'Rental Terms',
      subtitle: 'Choose the rental options that best fit your project needs and budget requirements.',
      rentalOptions: [
        {
          id: 1,
          title: 'With Operator',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Safety certified', 'Fully Insured', 'Project Expertise'],
        },
        {
          id: 2,
          title: 'Without Operator',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Lower Rental Costs', 'Full Control', 'Flexible Timing'],
        },
        {
          id: 3,
          title: 'Flexible Packages',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Weekly Discounts', 'Daily Rates', 'Long-Term Deals'],
        },
        {
          id: 4,
          title: 'On-Site Delivery',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Fast Delivery', 'Pickup Services', 'Setup Included'],
        },
      ],
    },
    sa: {
      title: 'شروط التأجير',
      subtitle: 'اختر خيارات التأجير التي تناسب احتياجات مشروعك ومتطلبات ميزانيتك بشكل أفضل.',
      rentalOptions: [
        {
          id: 1,
          title: 'مع مشغل',
          description: 'لوريم إيبسوم دولور سيت أميت كونسيكتيتور أديبيسسينغ إليت. إيجيستاس موليستي ليبر هوبتور.',
          features: ['معتمد من حيث السلامة', 'مؤمن بالكامل', 'خبرة المشروع'],
        },
        {
          id: 2,
          title: 'بدون مشغل',
          description: 'لوريم إيبسوم دولور سيت أميت كونسيكتيتور أديبيسسينغ إليت. إيجيستاس موليستي ليبر هوبتور.',
          features: ['تكاليف تأجير أقل', 'التحكم الكامل', 'توقيت مرن'],
        },
        {
          id: 3,
          title: 'باقات مرنة',
          description: 'لوريم إيبسوم دولور سيت أميت كونسيكتيتور أديبيسسينغ إليت. إيجيستاس موليستي ليبر هوبتور.',
          features: ['خصومات أسبوعية', 'أسعار يومية', 'عروض طويلة الأجل'],
        },
        {
          id: 4,
          title: 'التوصيل إلى الموقع',
          description: 'لوريم إيبسوم دولور سيت أميت كونسيكتيتور أديبيسسينغ إليت. إيجيستاس موليستي ليبر هوبتور.',
          features: ['توصيل سريع', 'خدمات الاستلام', 'يشمل الإعداد'],
        },
      ],
    },
    fr: {
      title: 'Conditions de location',
      subtitle: 'Choisissez les options de location qui correspondent le mieux aux besoins de votre projet et à vos exigences budgétaires.',
      rentalOptions: [
        {
          id: 1,
          title: 'Avec opérateur',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Certifié pour la sécurité', 'Entièrement assuré', 'Expertise du projet'],
        },
        {
          id: 2,
          title: 'Sans opérateur',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Coûts de location réduits', 'Contrôle total', 'Horaires flexibles'],
        },
        {
          id: 3,
          title: 'Forfaits flexibles',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Réductions hebdomadaires', 'Tarifs journaliers', 'Offres à long terme'],
        },
        {
          id: 4,
          title: 'Livraison sur site',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Livraison rapide', 'Services de ramassage', 'Installation incluse'],
        },
      ],
    },
    de: {
      title: 'Mietbedingungen',
      subtitle: 'Wählen Sie die Mietoptionen, die am besten zu Ihren Projektanforderungen und Budgetvorgaben passen.',
      rentalOptions: [
        {
          id: 1,
          title: 'Mit Bediener',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Sicherheitszertifiziert', 'Voll versichert', 'Projektexpertise'],
        },
        {
          id: 2,
          title: 'Ohne Bediener',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Niedrigere Mietkosten', 'Volle Kontrolle', 'Flexible Zeitplanung'],
        },
        {
          id: 3,
          title: 'Flexible Pakete',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Wöchentliche Rabatte', 'Tagespreise', 'Langfristige Angebote'],
        },
        {
          id: 4,
          title: 'Vor-Ort-Lieferung',
          description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit. Egestas molestie liber huptor.',
          features: ['Schnelle Lieferung', 'Abholdienste', 'Einrichtung inbegriffen'],
        },
      ],
    },
  };

  const t = translations[language] || translations.gb;

  const containerStyle = {
    backgroundColor: '#1a1a1a',
    minHeight: '100vh',
    padding: '80px 20px',
    fontFamily: 'Arial, sans-serif',
    overflow: 'hidden',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '80px',
  };

  const titleStyle = {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '20px',
    letterSpacing: '-1px',
  };

  const subtitleStyle = {
    fontSize: 'clamp(0.9rem, 1.5vw, 1.1rem)',
    color: '#b0b0b0',
    marginBottom: '30px',
    maxWidth: '600px',
    margin: '0 auto 30px auto',
    lineHeight: '1.6',
    padding: '0 20px',
  };

  const decorativeLineStyle = {
    width: '80px',
    height: '4px',
    background: 'linear-gradient(90deg, #ef4444, #f97316)',
    margin: '0 auto',
    borderRadius: '2px',
  };

  const cardWrapperStyle = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '40px',
    height: '100%',
  };

  const iconCircleStyle = {
    width: '80px',
    height: '80px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '30px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
    zIndex: 10,
    transition: 'all 0.3s ease',
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '50px 25px 30px 25px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
    textAlign: 'center',
    width: '100%',
    transition: 'all 0.3s ease',
    height: '100%',
    transform: 'translateY(0)',
    cursor: 'pointer',
  };

  const cardTitleStyle = {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '15px',
    transition: 'all 0.3s ease',
  };

  const cardDescStyle = {
    fontSize: '0.9rem',
    color: '#666',
    marginBottom: '25px',
    lineHeight: '1.5',
    transition: 'all 0.3s ease',
  };

  const featureListStyle = {
    listStyle: 'none',
    padding: 0,
    textAlign: language === 'sa' ? 'right' : 'left',
  };

  const featureItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    fontSize: '0.9rem',
    color: '#555',
    flexDirection: language === 'sa' ? 'row-reverse' : 'row',
    transition: 'all 0.3s ease',
  };

  return (
    <section style={containerStyle} className="py-5">
      <div className="container px-3">
        {/* Header */}
        <div style={headerStyle}>
          <h1 style={titleStyle} className="fw-bold display-4 display-md-3 display-lg-2">
            {t.title}
            <div className="d-flex justify-content-center mt-2">
              <div
                style={{
                  width: '40px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                }}
              ></div>
              <div
                style={{
                  width: '5px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                  margin: '0 4px',
                }}
              ></div>
              <div
                style={{
                  width: '40px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                }}
              ></div>
            </div>
          </h1>
          <p style={subtitleStyle}>{t.subtitle}</p>
          <div style={decorativeLineStyle}></div>
        </div>

        {/* Cards Section */}
        <div className="row g-4">
          {t.rentalOptions.map((option) => (
            <div key={option.id} className="col-lg-3 col-md-6">
              <div style={cardWrapperStyle}>
                {/* Icon Circle */}
                <div style={iconCircleStyle} className="card-icon">
                  <span style={{ fontSize: '2rem' }}>
                    {[
                      <FaUser size={40} style={{ color: 'red', padding: '10px', borderRadius: '50%' }} />,
                      <MdPerson size={40} style={{ color: 'red', padding: '10px', borderRadius: '50%' }} />,
                      <FaBoxOpen size={40} style={{ color: 'red', padding: '10px', borderRadius: '50%' }} />,
                      <FaTruckMoving size={40} style={{ color: 'red', padding: '10px', borderRadius: '50%' }} />,
                    ][option.id - 1]}
                  </span>
                </div>

                {/* Card */}
                <div
                  style={cardStyle}
                  className="animated-card"
                >
                  <h3 style={cardTitleStyle} className="card-title">{option.title}</h3>
                  <p style={cardDescStyle} className="card-desc">{option.description}</p>

                  {/* Features List */}
                  <ul style={featureListStyle}>
                    {option.features.map((feature, index) => (
                      <li key={index} style={featureItemStyle} className="feature-item">
                        <Icon
                          icon={circleTick}
                          width="16"
                          height="16"
                          style={{
                            color: '#ef4444',
                            marginRight: language === 'sa' ? '0' : '12px',
                            marginLeft: language === 'sa' ? '12px' : '0',
                            flexShrink: 0,
                          }}
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx>{`
        .animated-card:hover {
          transform: translateY(-10px) !important;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3) !important;
        }
        
        .animated-card:hover .card-icon {
          transform: translate(-50%, -60%) scale(1.1) !important;
          box-shadow: 0 15px 30px rgba(0,0,0,0.4) !important;
        }
        
        .animated-card:hover .card-title {
          color: #ef4444 !important;
        }
        
        .animated-card:hover .card-desc {
          color: #444 !important;
        }
        
        .animated-card:hover .feature-item {
          transform: translateX(${language === 'sa' ? '-5px' : '5px'});
        }
      `}</style>
    </section>
  );
};

export default RentalTerms;